// extracted by mini-css-extract-plugin
export default {"collectionSummaryFilter":"collection-summary_collectionSummaryFilter__OazMF","collectionSummaryTable":"collection-summary_collectionSummaryTable__D09iK"};